exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contentful-content{display:inline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dadf5308","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./WebResources/vue/shared/components/contentful/ContentfulText.vue
// module id = 452
// module chunks = 0 1 2 3 4 5 6 7 9 10 11 12 13 14 15 16 17 18 19 20 21 22